import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { Router, Switch } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { useTheme } from '@nbx/frontend-helpers/subscribe';
import EntryRoute from 'components/app/EntryRoute';

import { NBXAuth, NBXUsers, NBXReferral } from 'services';
import { ApplePayWalletExtension } from '@nbx/capacitor-apple-pay';
import { ConfigProvider } from '@nbx/config';

import SignupWrapper from 'components/app/SignupWrapper';
import { Login } from 'routes/Login';
import VerifyCode from 'routes/VerifyCode';
import VerifyEmail from 'routes/VerifyEmail';
import AccountAction from 'routes/AccountAction';
import ResetPassword from 'routes/ResetPassword';
import { MobileAppLoginRedirect } from 'routes/MobileAppLoginRedirect';
// eslint-disable-next-line import/no-unresolved
import { MobileSessionExpired } from 'routes/MobileSessionExpired';
import { OAuthAuthorization } from 'routes/OAuthAuthorization';
import { AddTwoFactorAuthSMSRoute } from 'routes/AddTwoFactorAuthSMS';

import store from './store';

const microapps = window.MICROFRONTENDS_CONFIG;

const routes = [
  { path: window.GET_LOCALE_PATHS(microapps.routes.resetPassword?.path), component: ResetPassword },
  { path: window.GET_LOCALE_PATHS(microapps.routes.signup?.path), component: SignupWrapper },
  {
    path: window.GET_LOCALE_PATHS(microapps.routes.addPhoneNumber?.path),
    component: AddTwoFactorAuthSMSRoute
  },
  { path: window.GET_LOCALE_PATHS(microapps.routes.verifyCode?.path), component: VerifyCode },
  { path: window.GET_LOCALE_PATHS(microapps.routes.verifyEmail?.path), component: VerifyEmail },
  { path: window.GET_LOCALE_PATHS(microapps.routes.accountAction?.path), component: AccountAction },
  { path: window.GET_LOCALE_PATHS(microapps.routes.login_home?.path), component: Login },
  { path: window.GET_LOCALE_PATHS(microapps.routes.login?.path), component: Login },
  {
    path: window.GET_LOCALE_PATHS(microapps.routes.loginMobileAppRedirect?.path),
    component: MobileAppLoginRedirect
  },
  { path: window.GET_LOCALE_PATHS(microapps.routes.oAuthAuthorization?.path), component: OAuthAuthorization },
  {
    path: window.GET_LOCALE_PATHS(microapps.routes.mobileSessionExpired?.path),
    component: MobileSessionExpired
  }
];

function App() {
  const [configured, setConfigured] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    const spinner = document.querySelector('#microfrontend_hook > .spinner');
    if (spinner) {
      spinner.parentNode.removeChild(spinner);
    }
    window
      .GET_API_CONFIG()
      .then(config => {
        NBXAuth.init(config.api.auth);
        NBXUsers.init(config.api.users);
        NBXReferral.init(config.api.referral);
        ApplePayWalletExtension.init(config.api.card);
        setConfigured(true);
      })
      .catch(error => {
        throw new Error('Error loading configuration file: ', error);
      });
  }, []);

  if (!configured) return null;

  return (
    <ConfigProvider defaults={{ auth_enroll_sms_2fa_on_signup_feature_flag: true }}>
      <HelmetProvider>
        <nbx-theme-provider theme={theme}>
          <Provider store={store}>
            <Router history={window.HISTORY}>
              <Switch>
                {routes.map(route => (
                  <EntryRoute path={route.path} component={route.component} exact key={route.path} />
                ))}
              </Switch>
            </Router>
          </Provider>
        </nbx-theme-provider>
      </HelmetProvider>
    </ConfigProvider>
  );
}

export default App;
